export function formatDate({ date }: { date: string }) {
  const transformDate = new Date(date)
  const day = transformDate.getUTCDate()
  const months = ['Jan', 'Fev', 'Mar', 'Abr', 'Mai', 'Jun', 'Jul', 'Ago', 'Set', 'Out', 'Nov', 'Dez']
  const month = months[transformDate.getUTCMonth()]

  return `${day} de ${month}`
}
